"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderEmiCardClickDL } from "./HeaderAnalyticsFunction";

interface HeaderEMICardProps {
  headerEMICard?: {
    ctaInNewTab: string;
    ctaLink: string;
    heading: string;
    isActiveClass: string;
    key: string;
    sectionID: string;
    showOnApp: string;
    showOnWeb: string;
    template: string;
  };
}

const EMICard: React.FC<HeaderEMICardProps> = ({ headerEMICard }) => {
  return (
    <BFLLink
      href={headerEMICard?.ctaLink}
      openInNewTab={headerEMICard?.ctaInNewTab}
      aria-label={headerEMICard?.heading ?? "EMI Card"}
      onClick={() => handleHeaderEmiCardClickDL()}
      className="order-3 m-0 flex flex-col items-center md:pt-[14px] md:pb-[8px] hover:bg-[#001326] md:order-4 md:gap-[5px] min-w-[44.05px] md:min-w-[56.62px]!"
    >
      <i className="icomoon text-2xl bf-icon-emi-card-new text-[#faba0a]"></i>
      <span className="hidden whitespace-nowrap text-xs leading-[14px] md:!block font-normal [font-family:Rubik,Mukta,BalooThambi2,sans-serif]">
        {headerEMICard?.heading ?? ""}
      </span>
    </BFLLink>
  );
};
export default EMICard;
